import { useEffect, useState } from "react";
import { X, Download } from "lucide-react";

const KEY = "lwco_install_tip_dismissed";
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia?.("(max-width: 767px)").matches;
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

// Small dismissible "Add to home screen" tip. Mobile only, never inside the installed app.
export default function InstallTip() {
  const [show, setShow] = useState(() => !isStandalone() && isMobile() && !localStorage.getItem(KEY));
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const onPrompt = e => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => setShow(false);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  if (!show) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  async function install() {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    setPrompt(null);
    if (outcome === "accepted") dismiss();
  }
  return (
    <div className="border border-neutral-700 bg-neutral-900 rounded p-3 flex items-start gap-3 text-sm" data-testid="install-tip">
      <img src="/icon-192.png" alt="" className="w-9 h-9 rounded" />
      <div className="flex-1">
        <div className="font-medium">Save the Hub to your home screen</div>
        {isIOS()
          ? <div className="opacity-80" data-testid="install-tip-ios">Tap Share, then Add to Home Screen.</div>
          : prompt
            ? <button className="btn-silver text-sm mt-2 px-4 py-2 flex items-center gap-1" onClick={install} data-testid="install-tip-button"><Download size={14} />Install app</button>
            : <div className="opacity-80" data-testid="install-tip-android">Open the browser menu (⋮), then tap Install app or Add to Home screen.</div>}
      </div>
      <button className="opacity-70 p-1" onClick={dismiss} aria-label="Dismiss" data-testid="install-tip-dismiss"><X size={16} /></button>
    </div>
  );
}
